import ReferrerLandingTemplate from '../../templates/referrer-landing.template';
import {useNavigate} from 'react-router-dom';
import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {LoadingFitoTemplate} from "../../templates/loading-fito.template.jsx";
import {fetchUserRewardInfoAPI} from "../../../services/new-services/referrals.service.js";
import {updateReferralCode} from "../../../redux/slices/application-process.slice.js";

const ReferrerLanding = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const referralCode = useSelector(state => state.applicationProcess.referralCode);
    const [referralInfo, setReferralInfo] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (!referralCode) {
            navigate('/app/application/initial-step');
            return;
        }
        fetchUserRewardInfoAPI(referralCode).then(res => {
            if (res.success) {
                setReferralInfo(res.rewardInfo);
                setIsLoading(false);
            } else {
                dispatch(updateReferralCode(null));
                navigate('/app/application/initial-step');
            }
        });
    }, []);

    return isLoading ? <LoadingFitoTemplate/> : (
        <ReferrerLandingTemplate referralDiscount={referralInfo?.totalDiscount / 100} onStartRequest={() => {
            navigate('/app/application/initial-step');
        }}/>
    );
};


export default ReferrerLanding;